import Restaurants0 from "./restaurants0.jpg";
import Restaurants1 from "./restaurants1.png";
import Restaurants2 from "./restaurants2.jpg";
import Restaurants3 from "./restaurants3.jpg";

export const RestaurantsImages = [
  Restaurants0,
  Restaurants1,
  Restaurants2,
  Restaurants3,
];
